export default __webpack_public_path__ + "static/media/masterspromos_buenfin_checo_330x330.3693fa97.jpg";